import React, { useState } from "react";
import { Grid, TextField } from "@material-ui/core";
import { Body, PrimaryButton, RegularButton, Spinner } from "@common";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import locale from "@bonliva-crm/locale";
import {
  useGetCustomerContractProfileInfoQuery,
  useSubmitCustomerContractInfoMutation,
  GetCustomerContractProfile
} from "@graphql";
import { useSnackbars } from "@hooks";
import { isEmpty } from "lodash";

type InfoDetailProps = {
  info: string;
  setIsEditInfo: (b: boolean) => void;
};

function InfoDetail(props: InfoDetailProps) {
  const { info, setIsEditInfo } = props;
  return (
    <Grid container spacing={2}>
      <Grid item xs={11}>
        <Body newlineToBr>{info}</Body>
      </Grid>
      <Grid item xs={1} style={{ textAlign: "right" }}>
        <IconButton onClick={(_) => setIsEditInfo(true)}>
          <EditIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}

type InfoEditProps = {
  id: string;
  info: string;
  setIsEditInfo: (b: boolean) => void;
};

function InfoEdit(props: InfoEditProps) {
  const { id, info, setIsEditInfo } = props;
  const [value, setValue] = useState(info);
  const [loading, setLoading] = useState(false);
  const { showSuccess, showError } = useSnackbars();

  const [submit] = useSubmitCustomerContractInfoMutation({
    refetchQueries: [GetCustomerContractProfile.OperationName]
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    submit({
      variables: {
        id,
        info: value
      }
    })
      .then(({ data: { submitCustomerContractInfo } }) => {
        const { errors } = submitCustomerContractInfo;
        console.log(submitCustomerContractInfo);
        if (!isEmpty(errors)) {
          throw new Error(errors.toString());
        }
        showSuccess("Info detail sent");
        setIsEditInfo(false);
      })
      .catch((err) => {
        showError(`Cannot update info \nReason: ${err}`);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label={"info"}
          multiline
          fullWidth
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </Grid>
      <Grid item alignContent={"flex-end"} xs={12}>
        <RegularButton onClick={() => setIsEditInfo(false)} style={{ marginRight: 15 }}>
          {locale.Cancel}
        </RegularButton>
        <PrimaryButton type="submit" loading={loading} onClick={handleSubmit}>
          {locale.Save}
        </PrimaryButton>
      </Grid>
    </Grid>
  );
}

type Props = {
  id: string;
};

export function InfoTab(props: Props) {
  const { id } = props;
  const [isEditInfo, setIsEditInfo] = useState(false);
  const { data, loading, error } = useGetCustomerContractProfileInfoQuery({
    variables: { id }
  });

  if (loading) {
    return <Spinner fullHeight />;
  }

  if (error) {
    return <div>{error.toString()}</div>;
  }

  const { info, _id } = data.customerContractById;
  return (
    <div style={{ minHeight: "200px", padding: 16 }}>
      {isEditInfo ? (
        <InfoEdit id={_id} info={info} setIsEditInfo={setIsEditInfo} />
      ) : (
        <InfoDetail info={info} setIsEditInfo={setIsEditInfo} />
      )}
    </div>
  );
}
